import { connect } from 'react-redux';
import { find, reject } from 'lodash';
import VisaDetailsComponent from './VisaDetailsComponent';
import {
  getDropdownOptions,
  getDropdownOptionsDiplomatic,
} from '../../../../services/Translation';
import {
  getVisaTypes,
  getVisaPurposes,
  getCountries,
  getConfig,
  getDiplomaticMission,
} from '../../../../state/reducers/ConfigReducer';
import {
  getData,
  getFormErrors,
  getValidators,
  isRequired,
  getError,
} from '../../../../state/reducers/ApplicationReducer';
import { getLanguage } from '../../../../state/reducers/AppReducer';
import ApplicationActions from '../../../../state/actions/ApplicationActions';

const mapStateToProps = state => {
  const dataConf = getConfig(state);
  const data = getData(state);
  const validators = getValidators(state);
  const errors = getFormErrors(state);
  const visaTypes = getVisaTypes(state) || [];
  const visaPurposes = getVisaPurposes(state) || [];
  const visaTypeId = data.visatypeId;
  const diplomaticMissionUuid = data.diplomaticMissionUuid;
  const { visapurposeId, nationalityCurrentId } = data;
  let countries = getCountries(state) || [];
  const lang = getLanguage(state);
  if (visaTypeId) {
    const selectedVisaType = find(visaTypes, { uuid: visaTypeId });
    if (selectedVisaType) {
      countries = reject(countries, c =>
        find(selectedVisaType.restrictedCountries, { uuid: c.uuid })
      );
    }
  }

  const selectedVisaPurpose =
    visaPurposes.find(item => item.uuid === visapurposeId) || {};
  const allowedVisaTypes = selectedVisaPurpose.allowedVisaTypes || [];

  const availableVisaTypes = visaTypes.filter(
    visaType =>
      !visaType.restrictedCountryIds.includes(data.nationalityCurrentId) &&
      allowedVisaTypes.includes(visaType.uuid)
  );

  return {
    config: dataConf,
    application: data,
    visaType: visaTypeId || null,
    diplomaticMission: diplomaticMissionUuid || null,
    isVisaTypeRequired: isRequired(validators.visatypeId),
    isDiplomaticMissionRequired: isRequired(validators.diplomaticMissionUuid),
    visaTypeError: errors.visatypeId,
    diplomaticMissionError: errors.diplomaticMissionUuid,
    visaPurpose: visapurposeId || null,
    isVisaPurposeRequired: isRequired(validators.visapurposeId),
    visaPurposeError: errors.visapurposeId,
    nationality: nationalityCurrentId || null,
    isNationalityRequired: isRequired(validators.nationalityCurrentId),
    nationalityError: errors.nationalityCurrentId,
    visaTypes: getDropdownOptions(availableVisaTypes, lang),
    visaPurposes: getDropdownOptions(getVisaPurposes(state), lang),
    nationalities: getDropdownOptions(countries, lang),
    diplomaticMissions: getDropdownOptionsDiplomatic(
      getDiplomaticMission(state),
      lang
    ),
    error: getError(state),
  };
};

const { formValueChanged } = ApplicationActions;
const mapDispatchToProps = dispatch => ({
  visaTypeChanged: visaType => {
    dispatch(formValueChanged('visatypeId', visaType));
  },
  visaPurposeChanged: visaPurpose =>
    dispatch(formValueChanged('visapurposeId', visaPurpose)),
  nationalityChanged: nationality =>
    dispatch(formValueChanged('nationalityCurrentId', nationality)),
  diplomaticMissionChanged: diplomaticMission =>
    dispatch(formValueChanged('diplomaticMissionUuid', diplomaticMission)),
  diplomaticMissionReset: () =>
    dispatch(formValueChanged('diplomaticMissionUuid', null)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VisaDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/VisaDetails/index.js